if(typeof open-ask-ai === 'undefined') { const e = new Error("Cannot find module 'open-ask-ai'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = open-ask-ai;